import { render, staticRenderFns } from "./ConnectWalletMenu.vue?vue&type=template&id=3fedfabd&scoped=true"
import script from "./ConnectWalletMenu.vue?vue&type=script&lang=ts"
export * from "./ConnectWalletMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fedfabd",
  null
  
)

export default component.exports